import {
    LOGIN,
    LOGOUT,
    SET_USER
} from './mutation-types'
import api from '@/api'

export function login ({ commit }, authToken) {
  api.defaults.headers.common['Authorization'] = 'Token ' + authToken
  commit(LOGIN, authToken)
}

export function logout ({ commit }) {
  commit(LOGOUT)
}

export function setUser ({ commit }, user) {
  commit(SET_USER, user)
}




// WEBPACK FOOTER //
// ./src/vuex/modules/user/actions.js